import { render, staticRenderFns } from "./defaultBlank.vue?vue&type=template&id=fc8e3c16&scoped=true"
import script from "./defaultBlank.vue?vue&type=script&lang=js"
export * from "./defaultBlank.vue?vue&type=script&lang=js"
import style0 from "./defaultBlank.vue?vue&type=style&index=0&id=fc8e3c16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8e3c16",
  null
  
)

export default component.exports